import React, { useId } from 'react';
import { useTranslation } from 'react-i18next';
import { Input } from 'components/ui/input';
import { useQuestionTopics } from 'modules/questionBank';
import { cn } from 'lib/utils';
import { MAX_TOPIC_CHARS } from './questionTopic';

interface Props {
  value: string;
  onChange: (value: string) => void;
  className?: string;
  labelClassName?: string;
}

/** Optional topic with the org's existing topics as native suggestions. */
export const QuestionTopicInput: React.FC<Props> = ({ value, onChange, className, labelClassName }) => {
  const { t } = useTranslation();
  const { data: topics } = useQuestionTopics();
  // useId yields ':r1:'; colons are awkward in selectors, so drop them.
  const id = `question-topic-${useId().replace(/:/g, '')}`;
  const listId = `${id}-suggestions`;

  return (
    <div className={cn('space-y-1.5', className)}>
      <label htmlFor={id} className={cn('block text-sm font-medium', labelClassName)}>
        {t('question_topic_label')}
      </label>
      <Input
        id={id}
        list={listId}
        value={value}
        maxLength={MAX_TOPIC_CHARS}
        placeholder={t('question_topic_placeholder')}
        autoComplete="off"
        onChange={(event) => onChange(event.target.value)}
      />
      <datalist id={listId}>
        {(topics ?? []).map((topic) => (
          <option key={topic} value={topic} />
        ))}
      </datalist>
    </div>
  );
};
